"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardAlignment = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _jsxRuntime = require("react/jsx-runtime");
var CardAlignment = exports.CardAlignment = /*#__PURE__*/function (CardAlignment) {
  CardAlignment["VERTICAL"] = "vertical";
  CardAlignment["HORIZONTAL"] = "horizontal";
  return CardAlignment;
}({});
var ImageWrapper = _styledComponents.default.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-xjwqrq-0"
})(["display:flex;width:", ";min-width:", ";align-items:center;justify-content:center;padding:", ";border-right:", ";border-bottom:", ";border-color:", ";"], function (_ref) {
  var alignment = _ref.alignment;
  return alignment === CardAlignment.HORIZONTAL ? '112px' : '100%';
}, function (_ref2) {
  var alignment = _ref2.alignment;
  return alignment === CardAlignment.HORIZONTAL ? '112px' : '100%';
}, _globalTokens.globalSpacing['400'], function (_ref3) {
  var alignment = _ref3.alignment;
  return alignment === CardAlignment.HORIZONTAL ? "".concat(_globalTokens.globalBorder.width.thin, " solid") : 'none';
}, function (_ref4) {
  var alignment = _ref4.alignment;
  return alignment === CardAlignment.VERTICAL ? "".concat(_globalTokens.globalBorder.width.thin, " solid") : 'none';
}, _globalTokens.globalColor.border.separator);
var Image = _styledComponents.default.img.withConfig({
  displayName: "Card__Image",
  componentId: "sc-xjwqrq-1"
})(["vertical-align:middle;height:auto;max-width:100%;"]);
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "Card__ContentWrapper",
  componentId: "sc-xjwqrq-2"
})(["display:flex;flex-direction:column;padding:", ";gap:", ";"], _globalTokens.globalSpacing['400'], _globalTokens.globalGap.s);
var BodyWrapper = _styledComponents.default.div.withConfig({
  displayName: "Card__BodyWrapper",
  componentId: "sc-xjwqrq-3"
})(["", " display:flex;flex-direction:column;gap:", ";"], _tokens.default.sky.sys.font.body['1'], _globalTokens.globalGap.l);
var CardWrapper = _styledComponents.default.div.withConfig({
  displayName: "Card__CardWrapper",
  componentId: "sc-xjwqrq-4"
})(["display:flex;width:", ";border-style:solid;border-width:", ";border-color:", ";flex-direction:", ";border-radius:", ";"], function (_ref5) {
  var width = _ref5.width;
  return width;
}, _globalTokens.globalBorder.width.thin, _globalTokens.globalColor.border.separator, function (_ref6) {
  var alignment = _ref6.alignment;
  switch (alignment) {
    case CardAlignment.VERTICAL:
      return 'column';
    case CardAlignment.HORIZONTAL:
    default:
      return 'row';
  }
}, _globalTokens.globalBorder.radius['5']);
var Title = _styledComponents.default.div.withConfig({
  displayName: "Card__Title",
  componentId: "sc-xjwqrq-5"
})(["display:flex;align-items:center;gap:", ";", " color:", ";"], _globalTokens.globalGap.s, _tokens.default.sky.sys.font.heading['4'], _globalTokens.globalColor.text.content.main);
var _Card = function Card(_ref7) {
  var onClick = _ref7.onClick,
    children = _ref7.children,
    src = _ref7.src,
    _ref7$alignment = _ref7.alignment,
    alignment = _ref7$alignment === void 0 ? _Card.ALIGNMENT.HORIZONTAL : _ref7$alignment,
    _ref7$width = _ref7.width,
    width = _ref7$width === void 0 ? '100%' : _ref7$width;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(CardWrapper, {
    onClick: onClick,
    alignment: alignment,
    width: width,
    children: [src && /*#__PURE__*/(0, _jsxRuntime.jsx)(ImageWrapper, {
      alignment: alignment,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Image, {
        src: src,
        alt: ''
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(ContentWrapper, {
      children: children
    })]
  });
};
var CardTitle = function CardTitle(_ref8) {
  var children = _ref8.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Title, {
    children: children
  });
};
var CardBody = function CardBody(_ref9) {
  var children = _ref9.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(BodyWrapper, {
    children: children
  });
};
_Card.Title = CardTitle;
_Card.Body = CardBody;
_Card.ALIGNMENT = CardAlignment;
var _default = exports.default = _Card;